import { render, staticRenderFns } from "./HeadingImageAbout.vue?vue&type=template&id=fea20cee&"
import script from "./HeadingImageAbout.vue?vue&type=script&lang=js&"
export * from "./HeadingImageAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports